// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// import { appConfig } from '../config/app.config';

class Logger {
    logger;

    constructor() {
        this.logger = console;
    }

    info(...params) {
        this.logger.info(...params);
    }

    log(...params) {
        // if (!appConfig.PRODUCTION_ENV) {
            this.logger.log(...params);
        // }
    }

    error(...params) {
        this.logger.error(...params);
    }

    debug(...params) {
        // if (!appConfig.PRODUCTION_ENV) {
            this.logger.debug(...params);
        // }
    }
}

const logger = new Logger();
export default logger;
